import { Image } from '@/components/ui';
import type { LevelSummary } from '@/features/guardian-player/components/player-progress-tracker/types';
import { buildPinUrl } from '@/features/player-session/utils';
import React, { useMemo } from 'react';

import { useStyles } from './styles';

type LevelSealProps = {
  item: LevelSummary;
};

export function LevelSeal({ item }: LevelSealProps) {
  const styles = useStyles();
  const pinUrl = useMemo(() => {
    const suffix = item.isLocked ? '_Disabled' : '';
    return buildPinUrl(`LV${item.level}_Overall${suffix}.png`);
  }, [item.isLocked, item.level]);

  return (
    <Image
      source={pinUrl ? { uri: pinUrl } : undefined}
      style={styles.levelSeal}
      resizeMode="contain"
    />
  );
}
